(function($){

	var $counter_interval;

	function makeTimer(hc, datetime) {

		var endTime = new Date(datetime);			
		endTime = (Date.parse(endTime) / 1000);

		var now = new Date();
		now = (Date.parse(now) / 1000);

		var timeLeft = endTime - now;

		var days = Math.floor(timeLeft / 86400); 
		var hours = Math.floor((timeLeft - (days * 86400)) / 3600);
		var minutes = Math.floor((timeLeft - (days * 86400) - (hours * 3600 )) / 60);
		var seconds = Math.floor((timeLeft - (days * 86400) - (hours * 3600) - (minutes * 60)));

		if (hours < "10") { hours = "0" + hours; }
		if (minutes < "10") { minutes = "0" + minutes; }
		if (seconds < "10") { seconds = "0" + seconds; }

		days_element = hc.querySelector('#days');
		hours_element = hc.querySelector('#hours');
		minutes_element = hc.querySelector('#minutes');
		seconds_element = hc.querySelector('#seconds');

		days_element.innerHTML = days + "<span>Days</span>";
		hours_element.innerHTML = hours + "<span>Hours</span>";
		minutes_element.innerHTML = minutes + "<span>Minutes</span>";
		seconds_element.innerHTML = seconds + "<span>Seconds</span>";

		if(timeLeft > 0) {
			hc.classList.add('active');
		} else {
			clearInterval($counter_interval);
		}
	}

	$hc_wrapper = document.querySelectorAll('.hero-countdown__wrapper');
	
	$hc_wrapper.forEach((hc) => {
		datetime = hc.dataset.datetime;
		if(datetime != '') {
			$counter_interval = setInterval(function() { makeTimer(hc, datetime); }, 100);		
		}
	});
	
})(jQuery);